// extracted by mini-css-extract-plugin
export default {"wrapper":"Services_wrapper__1yOmQ","content":"Services_content__ZolwY"};